function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { useRef, useState } from "react";
import { XS } from "components/core/new-button/button-component";
import PictureComponent from "components/core/picture/picture-component";
import CheckboxSVG from "segments/desktop/core-components/product-card/checkbox-icon";
import SignupButton from "segments/desktop/core-components/button/signup-button/signup-button";
import SelectableTag from "segments/desktop/core-components/selectable-tag/selectable-tag";
import { StyledSelectableProductCard } from "./selectable-product-card.scss";
import { BUTTON_CONFIG_BY_PRODUCT, PRODUCT_ID_TO_COLOR, PRODUCT_ID_TO_LOGO } from "./consts";
import colors from "styles/colors";
import { RACKLEY_BLUE, WHITE_COLOR_NAME } from "styles/color-consts";
import { trackEvent } from "services/bigbrain-service";
import { CAROUSEL_PRODUCT_TAG_CLICKED } from "constants/bigbrain-event-types";
const SelectableProductCard = ({ cardAsset, onClick, useCases, productType, tag, selectableTags })=>{
    const [isHovered, setIsHovered] = useState(false);
    const [isHoverTransition, setIsHoverTransition] = useState(false);
    const [isTagSelected, setIsTagSelected] = useState(false);
    const cardRef = useRef(null);
    const [tagAnimationActivated, setTagAnimationActivated] = useState(false);
    const handleMouseEnter = ()=>{
        setIsHovered(true);
        setIsHoverTransition(false);
    };
    const handleMouseLeave = ()=>{
        if (isHovered) setIsHoverTransition(true);
        setIsHovered(false);
    };
    const onCardClick = ()=>{
        trackEvent(CAROUSEL_PRODUCT_TAG_CLICKED, {
            kind: tag.tagText
        });
        if (!selectableTags) return;
        setIsTagSelected((isSelected)=>!isSelected);
        onClick && onClick();
        cardRef === null || cardRef === void 0 ? void 0 : cardRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
        setTagAnimationActivated(true);
    };
    return /*#__PURE__*/ _jsxs(StyledSelectableProductCard, {
        ref: cardRef,
        isSelectable: selectableTags,
        onAnimationEnd: ()=>setTagAnimationActivated(false),
        onClick: onCardClick,
        className: classnames("carousel-product-card", {
            "card-animation": tagAnimationActivated
        }),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: [
            (tag === null || tag === void 0 ? void 0 : tag.tagText) && /*#__PURE__*/ _jsx("div", {
                className: "card-tag",
                children: /*#__PURE__*/ _jsx(SelectableTag, {
                    defaultFillColor: colors[RACKLEY_BLUE],
                    tagText: tag.tagText,
                    isSelected: isTagSelected,
                    tagBackgroundColor: selectableTags ? WHITE_COLOR_NAME : "transparent",
                    showMobileClusterTags: !selectableTags,
                    darkMode: true
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "picture-wrapper",
                children: /*#__PURE__*/ _jsx(PictureComponent, {
                    src: cardAsset
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: classnames("card-content", {
                    up: isHovered,
                    down: isHoverTransition
                }),
                children: [
                    productType && /*#__PURE__*/ _jsx("div", {
                        className: "product-logo-wrapper",
                        children: /*#__PURE__*/ _jsx(PictureComponent, {
                            src: PRODUCT_ID_TO_LOGO[productType]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "use-cases-wrapper",
                        children: useCases === null || useCases === void 0 ? void 0 : useCases.map(({ useCase })=>/*#__PURE__*/ _jsxs("div", {
                                className: "use-case",
                                children: [
                                    /*#__PURE__*/ _jsx(CheckboxSVG, {}),
                                    useCase
                                ]
                            }, useCase))
                    }),
                    !selectableTags && /*#__PURE__*/ _jsx("div", {
                        className: "product-signup-wrapper",
                        children: /*#__PURE__*/ _jsx(SignupButton, _object_spread_props(_object_spread({
                            buttonSize: XS,
                            extraData: {
                                tag: tag === null || tag === void 0 ? void 0 : tag.tagText,
                                productType
                            }
                        }, BUTTON_CONFIG_BY_PRODUCT[productType]), {
                            buttonColor: PRODUCT_ID_TO_COLOR[productType],
                            withButtonArrow: false
                        }))
                    })
                ]
            })
        ]
    });
};
export default SelectableProductCard;
